import { render, staticRenderFns } from "./packagesuser.vue?vue&type=template&id=6db23ccc&"
import script from "./packagesuser.vue?vue&type=script&lang=js&"
export * from "./packagesuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports